import { render, staticRenderFns } from "./SwitchSolicitarSelfieAssinatura.vue?vue&type=template&id=303401d0&scoped=true"
import script from "./SwitchSolicitarSelfieAssinatura.vue?vue&type=script&lang=js"
export * from "./SwitchSolicitarSelfieAssinatura.vue?vue&type=script&lang=js"
import style0 from "./SwitchSolicitarSelfieAssinatura.vue?vue&type=style&index=0&id=303401d0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303401d0",
  null
  
)

export default component.exports